exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-can-request__tooltip[data-v-7ae4c0e5]{position:absolute;background:#7875d0;width:300px;padding:6px 8px;font-size:12px;line-height:1.4;text-align:center;color:#fff;border-radius:4px;box-shadow:0 2px 12px 0 rgba(51,50,85,.6);top:40px;left:0;transition:all .3s ease;transition-delay:.1s;z-index:10;opacity:0;visibility:hidden}.btn-can-request__tooltip_on[data-v-7ae4c0e5]{opacity:1;visibility:visible}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ae4c0e5","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/presets/button/can-request/component.vue
// module id = aa4bb701857b7ed75dda
// module chunks = 0